import { useState } from 'react';
import http from '../../services/http';
import { useAuthStore } from '../../store/authStore';
import { toast } from 'react-hot-toast';

export default function ImpersonationBanner() {
    const user = useAuthStore((state) => state.user);
    const clearUser = useAuthStore((state) => state.clearUser);
    const setInitialized = useAuthStore((state) => state.setInitialized);
    const [isStopping, setIsStopping] = useState(false);

    const impersonation = user?.impersonation;

    if (!impersonation) {
        return null;
    }

    const handleStop = async () => {
        if (isStopping) {
            return;
        }

        setIsStopping(true);

        try {
            const response = await http.post<{ success: boolean; redirect_url?: string; message?: string }>(
                '/admin/impersonate/stop',
            );

            clearUser();
            setInitialized(false);

            window.location.href = response.data.redirect_url || '/dashboard';
        } catch (error) {
            console.error('Failed to stop impersonation', error);
            toast.error('Could not return to your account. Please try again.');
            setIsStopping(false);
        }
    };

    return (
        <div className="flex w-full items-center justify-between gap-3 bg-purple-700 px-4 py-2 text-sm text-white">
            <div className="flex items-center gap-2">
                <i className="fas fa-user-secret" />
                <span>
                    You are impersonating <strong>{user?.name}</strong> as{' '}
                    <strong>{impersonation.impersonator_name}</strong>.
                </span>
            </div>

            <button
                type="button"
                onClick={handleStop}
                disabled={isStopping}
                className="rounded bg-white px-3 py-1 text-xs font-medium text-purple-700 hover:bg-purple-100 disabled:opacity-60"
            >
                {isStopping ? 'Returning…' : 'Return to my account'}
            </button>
        </div>
    );
}
